module.exports = __webpack_public_path__ + "img/chain-bridge.a0b188a.jpg";